import React from "react";
import { useParams } from "react-router-dom";

export default function RWAFiltered() {
  const { type } = useParams();

  const LazyComponent = React.lazy(() =>
    import(`./filtered/${type}.jsx`).catch(() =>
      import('./filtered/Product.jsx')
    )
  );

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <LazyComponent />
    </React.Suspense>
  );
}
